import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  agmPresence: [],
  error: false,
  success: false,
  presence: {},
  loading: false,
  exportLoading: false,
  exportSuccess: false,
  downloadLink: '',
  totalQuotePart: '',
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Reports/AGM/index.js